export default class Job {
  public id!: string;
  public name !: string;
  public description !: string;
  public startYear !: number;
  public endYear !: number;
  public workingHere !: boolean;
  public location !: string;
  public url !: string;
  public posts !: string[];
}